import {
  EMAIL_REGEX,
  PASSWORD_REGEX,
} from "@circle-react/components/OnboardingPage/helpers/constants";
import { CheckoutForm } from "@circle-react/components/Paywalls/Checkout/CheckoutV2/CheckoutForm";
import { usePaywallCheckoutContext } from "@circle-react/contexts/Paywalls/paywallCheckoutContext";
import { CheckoutFormField } from "../CheckoutFormField";

export const CheckoutFormAccountFields = () => {
  const { currentUser } = usePaywallCheckoutContext();

  if (currentUser) {
    return null;
  }

  return (
    <>
      <CheckoutForm.Item name="email">
        <CheckoutFormField
          type="text"
          name="email"
          options={{
            required: true,
            pattern: EMAIL_REGEX,
          }}
        />
      </CheckoutForm.Item>
      <CheckoutForm.Item name="password">
        <CheckoutFormField
          type="password"
          name="password"
          options={{
            required: true,
            pattern: PASSWORD_REGEX,
          }}
        />
      </CheckoutForm.Item>
    </>
  );
};
